module.exports = __webpack_public_path__ + "media/images/favicon/favicon-32x32-0924b5f489f24794eebb61e25ef3c7c5.png";